/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BasketDiscountCreateRequest } from '../../models/basket-discount-create-request';
import { BasketDiscountCreateResponse } from '../../models/basket-discount-create-response';
import { DiscountCreateResponse } from '../../models/discount-create-response';
import { QuantityDiscountCreateRequest } from '../../models/quantity-discount-create-request';
import { QuantityDiscountCreateResponse } from '../../models/quantity-discount-create-response';
import { SegmentDiscountCreateRequest } from '../../models/segment-discount-create-request';
import { SegmentDiscountCreateResponse } from '../../models/segment-discount-create-response';

export interface CreateDiscount$Params {
      body: (BasketDiscountCreateRequest | QuantityDiscountCreateRequest | SegmentDiscountCreateRequest)
}

export function createDiscount(http: HttpClient, rootUrl: string, params: CreateDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)>> {
  const rb = new RequestBuilder(rootUrl, createDiscount.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)>;
    })
  );
}

createDiscount.PATH = '/discounts';
